export default __webpack_public_path__ + "static/media/poll_1.2a525d12.jpg";